import React from 'react'

export default () =>
  <hr
    style={{
      position: 'relative',
      top: '2px',
    }}
  />
